import { getBOMSerialName } from "@/request/view/project";

export const getSeriesNameByProject = (projectLifeCycleId) => {
    return new Promise((resolve, reject) => {
        getBOMSerialName({
            projectLifeCycleId,
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        });
    });

}